import { apiClient } from "../lib/apiClient";

export const baseService = {
  get: (url, params) => apiClient.get(url + buildQuery(params)),
  post: (url, data) => apiClient.post(url, data),
  put: (url, data) => apiClient.put(url, data),
  patch: (url, data) => apiClient.patch(url, data),
  delete: (url) => apiClient.delete(url),
};

function buildQuery(params) {
  if (!params) return "";
  const search = new URLSearchParams(params).toString();
  return search ? `?${search}` : "";
}
